(function () {
  'use strict';

  var sheet    = document.querySelector('.vsp');
  var backdrop = document.querySelector('.vsp-backdrop');
  if (!sheet || !backdrop) return;

  var atcBtn   = sheet.querySelector('.vsp__atc-btn');
  var closeBtn = sheet.querySelector('.vsp__close');
  var formId   = sheet.dataset.formId;

  var section = document.querySelector('.shopify-section--main-product');
  if (!section) return;

  /* ── Event delegation on stable section (survives variant rerender) ── */
  section.addEventListener('click', function (e) {
    var label = e.target.closest(
      '.pack-variant-list label.pack-variant-card,' +
      '.variant-picker__option-values label.block-swatch,' +
      '.variant-picker__option-values label.thumbnail-swatch'
    );
    if (!label) return;
    if (label.classList.contains('is-disabled')) return;

    // Let the native radio update first, then open popup
    setTimeout(openSheet, 0);
  });

  /* ── ATC button ───────────────────────────────────────────── */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      // Re-query form each time — DOM may have been replaced by rerender
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      var orig = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      var formData = new FormData();
      formData.append('id', idInput.value);
      formData.append('quantity', '1');

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));
      if (sectionsToBundle.length) {
        formData.append('sections', sectionsToBundle.join(','));
        formData.append('sections_url', Shopify.routes.root + 'variants/' + idInput.value);
      }

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (result) {
        atcBtn.disabled = false;
        atcBtn.textContent = orig;
        if (!result.ok) return;
        return fetch(Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartContent) {
            cartContent['sections'] = result.json['sections'];
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer',
                cart: cartContent
              }
            }));
            closeSheet();
          });
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = orig;
      });
    });
  }

  /* ── Open / close ─────────────────────────────────────────── */
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);
  if (backdrop) backdrop.addEventListener('click', closeSheet);

  function openSheet() {
    backdrop.removeAttribute('hidden');
    sheet.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        sheet.classList.add('is-visible');
      });
    });
  }

  function closeSheet() {
    backdrop.classList.remove('is-visible');
    sheet.classList.remove('is-visible');
    var onEnd = function () {
      backdrop.setAttribute('hidden', '');
      sheet.setAttribute('hidden', '');
      backdrop.removeEventListener('transitionend', onEnd);
    };
    backdrop.addEventListener('transitionend', onEnd);
  }
})();
